export enum EntityScreenType {
    EntityScreen = 'entity'
}

export enum EntityScreenTabType {
    share = 'share',
    self = 'self'
}

export class EntityScreenTab {
    id: string;
    name: string;
    screenId: string;
    screenType: string;
    type: EntityScreenTabType;
    editable: boolean;

    constructor(id, name, screenId, screenType, type, editable) {
        this.id = id;
        this.name = name;
        this.screenId = screenId;
        this.screenType = screenType;
        this.type = type;
        this.editable = editable;
    }
}

export class EntityScreenConfig {
    id: string;
    name: string;
    description: string;
    type: EntityScreenType;
    isPublic: boolean;
    tabs: EntityScreenTab[];
    accessList: Array<string>;

    constructor() {
        this.id = '';
        this.name = '';
        this.description = '';
        this.type = EntityScreenType.EntityScreen;
    }
}
